export default __webpack_public_path__ + "static/media/icon-report-time.426720ab.svg";